import { GET_AREAS } from "./actionTypes";

export const getAreasAction = (areas) => {
  return {
    type: GET_AREAS,
    payload: areas
  };
};
